import { render, staticRenderFns } from "./RelayEcologyPanel.vue?vue&type=template&id=1d337486&scoped=true"
import script from "./RelayEcologyPanel.vue?vue&type=script&lang=js"
export * from "./RelayEcologyPanel.vue?vue&type=script&lang=js"
import style0 from "./RelayEcologyPanel.vue?vue&type=style&index=0&id=1d337486&prod&lang=scss&scoped=true"
import style1 from "./RelayEcologyPanel.vue?vue&type=style&index=1&id=1d337486&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d337486",
  null
  
)

export default component.exports